import { render, staticRenderFns } from "./AddressRequirementsAgreementDialog.vue?vue&type=template&id=a7cabd04&scoped=true&lang=pug&"
import script from "./AddressRequirementsAgreementDialog.vue?vue&type=script&lang=ts&"
export * from "./AddressRequirementsAgreementDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7cabd04",
  null
  
)

export default component.exports